import {app} from '../app';
import IPromise = angular.IPromise;

export class ErrorService {

    private q:ng.IQService;

    private httpErrorResponse:ng.IHttpPromiseCallbackArg<any>;
    private resumeConnectionCallbacks:(() => void)[] = [];
    private lostConnectionCallbacks:(() => void)[]   = [];

    constructor($q:ng.IQService) {
        this.q = $q;
    }

    httpError(response:ng.IHttpPromiseCallbackArg<any>) {
        angular.element('#lost-connection').modal({
            keyboard: false,
            backdrop: 'static'
        }).modal('show');

        this.httpErrorResponse = response;

        this.lostConnectionCallbacks.forEach(callback => callback());
    }

    getHttpErrorResponse():ng.IHttpPromiseCallbackArg<any> {
        return this.httpErrorResponse;
    }

    onLostConnection(callback:() => void):() => void {
        const index = this.lostConnectionCallbacks.push(callback) - 1;

        return () => {
            this.lostConnectionCallbacks.splice(index, 1);
        };
    }

    onResumeConnection(callback:() => void):() => void {
        const index = this.resumeConnectionCallbacks.push(callback) - 1;

        return () => {
            this.resumeConnectionCallbacks.splice(index, 1);
        };
    }

    runResumeConnectionCallbacks() {
        this.resumeConnectionCallbacks.forEach(callback => callback());
    }

    static factory() {
        const factory   = ($q:ng.IQService) => new ErrorService($q);
        factory.$inject = ['$q'];
        return factory;
    }
}

app.factory('ErrorService', ErrorService.factory());